export default "__VITE_ASSET__CEfR0uD3__"